module.exports = __webpack_public_path__ + "img/svg/smile.5c7841c15c704ab2c6b7cdda19f1746a.svg";